<template>
  <div class="couponBox">
    <div :style="{width: '110px', height: '80px', backgroundImage: `url(${image.startsWith('http') ? image : image.replace('/', '')})`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}"></div>
    <div class="desc">
      <div label="活動名稱: ">{{couponName}}</div>
      <div label="贈品名稱: ">{{productName}}</div>
      <div label="活動日期: ">
        <span v-if="duration===0">發券日當天</span>
        <span v-else-if="duration">發券日起{{duration}}天</span>
        <span v-else>{{startTime ? toDate(startTime) : '即日起'}} ~ {{toDate(expireTime)}}</span> </div>
    </div>
    <button @click="$emit('selectThis')"><iconPlus v-if="icon==='select'"/><iconDelete v-else-if="icon==='delete'" color="#E37878" color2="transparent"/></button>
  </div>
</template>

<script>
import iconPlus from '../SVG/iconPlus'
import iconDelete from '../SVG/iconDelete'
export default {
  components: {
    iconPlus,
    iconDelete
  },
  props: {
    icon: {
      type: String,
      default: 'select'
    },
    image: {
      type: String,
      default: '/coffee.png'
    },
    couponName: {
      type: String,
      default: ''
    },
    productName: {
      type: String,
      default: ''
    },
    productID: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    expireTime: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    }
  }

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
button {
  position: absolute;
  top: 13px;
  right: 13.33px;
  background-color: transparent;
  border: none;
  width: 43px;
  height: 43px;
  padding: 0;
  margin: 0;
}
img {
  max-width: 110px;
  height: 110px;

  resize: both;
}
.desc {
  display: flex;
  flex-direction: column;
  // gap: 10px;
}
.desc > div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #5E5E5E;
  gap: 12px;
  &::before {
    content: attr(label);
  }
}
.couponBox {
  position: relative;
  width: 760px;
  height: 120px;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px;
  gap: 14px;
  display: grid;
  grid-template-columns: 110px 1fr;
}
</style>
